import React, {Component, ReactNode} from 'react'
import styled from 'styled-components'
import {CookieHelper} from '../../CookieHelper'
import {HKConstants} from '../../HKConstants'
import {Colors} from '../../styledComponents/Constants'
import {Box} from '@mui/material'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import AdminAuthRepository from '../../__NoAutomatedTests/components/login/repository/AdminAuthRepository'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import {AppAdminContext} from '../../app/AppAdminContext'
import {Location} from 'react-router-dom'

interface Props {
    adminAuthRepo: AdminAuthRepository
    location: Location
}

interface State {
    isLoadCompleted: boolean
}

class AdminLoginPortalPage extends Component<Props & AdminPagePropsSet, State> {
    declare context: React.ContextType<typeof AppAdminContext>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {isLoadCompleted: false}
    }

    async componentDidMount(): Promise<void> {
        const loginRootInfo = CookieHelper.getStringValue(HKConstants.VMN.SYS.COOKIE_KEY_LOGIN_ROUTE)
        if (loginRootInfo === HKConstants.VMN.SYS.LOGIN_ROUTE_ASSOC) {
            this.pageTransition('/admin/assoc/login')
            return
        }
        if (loginRootInfo === HKConstants.VMN.SYS.LOGIN_ROUTE_ADMIN ||
            loginRootInfo === HKConstants.VMN.SYS.LOGIN_ROUTE_AD) {
            this.pageTransition('/admin/login')
            return
        }

        // ログアウトボタンを押下せずにログインポータル画面へ遷移した場合はログアウト処理を行う。
        // 一般的な操作では管理者または管理組合のログイン画面に遷移しこちらのパスにはこない。念の為の処理。
        if (SessionStorageHelper.existsAnyItem()) {
            await this.props.eventEmitter.showLoading()
            try {
                await this.props.asyncCallFunction(
                    this.props.adminAuthRepo.logout.bind(this.props.adminAuthRepo),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
            } finally {
                this.props.eventEmitter.closeLoading()
                SessionStorageHelper.removeAllItem()
            }
        }

        this.setState({isLoadCompleted: true})
    }

    pageTransition(path: string): void {
        const queryParam = this.props.location.search.slice(1)
        if (queryParam === '') {
            this.props.navigate(path)
        } else {
            this.props.navigate({
                pathname: path,
                search: queryParam,
            })
        }
    }

    handleClickAssocLoginCard = (): void => {
        this.pageTransition('/admin/assoc/login')
    }

    handleClickAdminLoginCard = (): void => {
        this.pageTransition('/admin/login')
    }

    render(): ReactNode {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return <MainContainer>
            <div>素敵ネット管理用を利用する場合は、以下を選択しログインしてください。</div>
            <CardContainer spMode={spMode}>
                <LinkCard
                    spMode={spMode}
                    onClick={this.handleClickAssocLoginCard}
                >
                    <LoginButtonIconImage src={'/resources/images/assoc/assoc_login_black.svg'}/>
                    <LoginButtonTitleSpan>管理組合役員の方</LoginButtonTitleSpan>
                </LinkCard>
                <Box width={'32px'} height={'16px'}/>
                <LinkCard
                    spMode={spMode}
                    onClick={this.handleClickAdminLoginCard}
                >
                    <LoginButtonIconImage src={'/resources/images/print/haseko_icon.svg'}/>
                    <LoginButtonTitleSpan>長谷工グループの方</LoginButtonTitleSpan>
                </LinkCard>
            </CardContainer>
        </MainContainer>
    }
}

AdminLoginPortalPage.contextType = AppAdminContext
export default createAdminPage(AdminLoginPortalPage)

const MainContainer = styled.div`
  margin-top: 17px;
  width: 100%;
`

const LoginButtonTitleSpan = styled.span`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 18px;
  font-weight: bold;
  margin-left: 24px;
`

const LoginButtonIconImage = styled.img`
  width: 32px;
  height: 32px;
`

const CardContainer = styled.div<{ spMode: boolean }>`
  margin-top: 24px;
  display: flex;
  flex-direction: ${props => props.spMode ? 'column' : 'row'};
`

const LinkCard = styled.div<{ spMode: boolean }>`
  cursor: pointer;
  height: 100px;
  box-shadow: 0 1px 8px ${Colors.LightShadow};
  border-radius: 4px;
  background-color: ${Colors.Surface};
  padding: 0 32px;
  ${props => props.spMode
          ? 'width: 100%;'
          : 'flex-grow: 1;'}
  display: flex;
  flex-direction: row;
  align-items: center;
`
